export const host = '.';
export const apiVersion = "v1"
export const apiUrl = `${host}/api/${apiVersion}`;
export const tenantId = "b458b9fe-f797-4f7c-a45e-69d54a7ea236";
export const multipleTenantId = "common";

export const environment = {
  production: true,

  // Keycloak SSO. Disabled until the production Keycloak URL is supplied: enabled:false hides
  // the SSO button and short-circuits KeycloakService.init() before any network call, so a
  // production build is safe to ship in this state.
  // TODO fill in url/realm/clientId, then set enabled:true. Note the backend's
  // RequireHttpsMetadata=false is a DEV-only setting and must be reviewed before prod SSO.
  keycloak: {
    enabled: true,
    url: 'https://sso.altusentertainment.com',
    realm: 'altus',
    clientId: 'backoffice-spa',
  },
  host,
  maxSizeUpload: 20971520,//20MB
  formatDateTime: 'MM/dd/yyyy HH:mm:ss',
  formatDateTimeZone: "yyyy-MM-dd'T'HH:mm:ss x",
  formatDate: 'MM/dd/yyyy',
  formateHoursTime: 'HH:mm:ss',
  apiAuth: apiUrl + '/auth',
  apiUser: apiUrl + '/usermanagement',
  apiCustomView: apiUrl + '/customview',
  apiProfile: apiUrl + '/profilemanagement',
  apiProfileManagement: apiUrl + '/profilemanagement',
  apiCategory: apiUrl + '/categorymanagement',
  apiContactManagement: apiUrl + '/contactmanagement',
  tagManagement: apiUrl + '/tagmanagement',
  locationManagement: apiUrl + '/locationmanagement',
  reasonManagement: apiUrl + '/reasonmanagement',
  seoInfoManagement: apiUrl + '/seomanagement',
  apiProducer: apiUrl + '/producermanagement',
  mediaManagement: apiUrl + '/mediamanagement',
  apiEnquiry: apiUrl + '/EnquiryBasketManagement',
  apiBooking: apiUrl + '/BookingManagement',
  apiActivityLog: apiUrl + '/ActivityLog',
  apiSetting: apiUrl + '/SettingManagement',
  apiBioRewrite: apiUrl + '/BioRewriteManagement',
  //2022-03-21 thoai add start
  apiSeoInfo: apiUrl + '/SeoManagement',
  //2022-03-21 thoai add end

  //2021-11-5 HMTien add start
  maxImageSizeUpload: 3145728, //3mb 02/03/2022 hmtien update
  //2021-11-5 HMTien add end
  //2022-03-21 hmtien add start
  apiOnboardingData: apiUrl + '/OnboardingData',
  //2023-03-21 hmtien add end
  apiTaskStatus: apiUrl + '/TaskManagement',
  apiTaskType: apiUrl + '/TaskManagement',

  apiDashboard: apiUrl + '/Dashboard',
  apiCampaign: apiUrl + '/CampaignManagement',
  apiTaskManagement: apiUrl + '/TaskManagement',
  aipNotification: apiUrl + '/Notification',
  apiOnboarding: apiUrl + '/OnBoarding',
  apiSummaryReport: apiUrl + '/SummaryReport',
  apiPermission: apiUrl + '/PermissionManagement',
  apiRole: apiUrl + '/rolemanagement',
  changeLogUrl: apiUrl + '/ChangeLogManagement',
  apiDiagnosticHistory: apiUrl + '/DiagnosticHistory',

  //2022-02-04 toanpq add start
  apiTaskScriptManagement: apiUrl + '/TaskScriptManagement',
  apiTaskScript: apiUrl + '/TaskScriptManagement',
  apiTaskScriptGroup: apiUrl + '/TaskScriptGroupManagement',
  apiTaskTemplate: apiUrl + '/TaskTemplateManagement',
  //2022-02-04 toanpq add end
  //2022-03-30 hmtien add start
  apiTaskPlanHistory: apiUrl + '/TaskPlanHistoryManagement',
  apiAutoAssignmentReport: apiUrl + '/AutoAssignmentReportManagement',
  //2022-03-30 hmtien add end
  apiSpotlightr: 'https://api.spotlightr.com/api',
  apiTracking: apiUrl + '/Tracking',
  apiAccessLog: apiUrl + '/AccessLogManagement',
  apiAutomateDataState: apiUrl + '/AutomateDataState',
  //2022-04-13 toanpq add datastate table
  apiDatastateManagement: apiUrl + '/DatastateManagement',
  apiBuyer: apiUrl + '/BuyerManagement',

  //2022-04-28 thoai add start
  apiCallEvent: apiUrl + '/CallEventManagement',
  //2022-04-28 thoai add end
  //2022/18/08 thangnpq add start
  apiCallbackMapping: apiUrl + '/CallbackMappingManagement',
  //2022/18/08 thangnpq add end
  apiSupportTicket: apiUrl + '/SupportTicket',
  apiAdminQueries: apiUrl + '/AdminQueries',
  apiQueryHistory: apiUrl + '/QueryHistory',
  apiFontFacing: apiUrl + '/FontFacing',
  apiFileSyncProgress: apiUrl + '/FileSyncProgress',
  apiSystemLogs: apiUrl + '/SystemLogsManagement',
  apiEmailAttachment: apiUrl + '/EmailAttachmentManagement',
  apiPageSpeed: apiUrl + '/PageSpeedManagement',
  apiPhotoProcessQueue: apiUrl + '/PhotoProcessQueueManagement',
  clientId: "7f6b7400-c61f-4196-9c78-5fff9bd6f4ab",
  multipleTenantClientId: "cef1072d-e351-4335-93fc-a6bf99512bc4",
  authority: `https://login.microsoftonline.com/${tenantId}`,
  multipleTenantAuthority: `https://login.microsoftonline.com/${multipleTenantId}`,
  redirectUri: "https://app.altusentertainment.com/",
  apiMapViewCategory: apiUrl + '/MapViewCategory',
  apiDataFields: apiUrl + '/DataFieldsManagement',
  apiSaleLead: apiUrl + '/SaleLeadManagement',
  apiPageNote: apiUrl + '/UserNoteManagement',
  realtimeNotification: apiUrl + '/RealtimeNotification',
  apiSaleOpportunity: apiUrl + '/SaleOpportunityManagement',
  apiSaleAccount: apiUrl + '/SaleAccountManagement',
  apiApiJob: apiUrl + '/ApiJob',
  apiUserTab: apiUrl + '/UserTabManagement',
  apiDynamicContent: apiUrl + '/DynamicContentManagement',
  apiProfileAdditionDetailManagement: apiUrl + '/ProfileAdditionDetailManagement',
  apiUserUpload: apiUrl + '/FileManagerBusiness',
  apiSaleConvertHistory: apiUrl + '/SaleConvertHistoryManagement',
  apiReminderHistory: apiUrl + '/ReminderHistoryManagement',
  apiUserToken: apiUrl + '/UserTokenManagement',
  apiFrontPageData: apiUrl + '/FrontFacing',
  apiGoogleSearchConsole: apiUrl + '/GoogleSearchConsole',
  titleLead: 'Prospect', //Leads => Prospect
  titleAccount: 'Client', //Account => Client
  titleOpportunity: 'Project', //Opportunity => Request for Project
  apiMessage: apiUrl + '/MessageManagement',
  apiSMSManagement: apiUrl + '/SMSManagement',
  titleProfile: 'Artist',
  title1xService: 'Client Fee',
  title1xProduct: 'Total Talent Cost',
  titleTotalValue: 'Profit',
  titleEstimate: 'Budget',
  titleClosedDate: 'Event Date',
  titleEmployee: 'Performer',
  apiClickUp: apiUrl + '/ClickUp',
  apiUserAction: apiUrl + '/UserActionManagement',
  apiStepInFlow: apiUrl + '/StepInFlowManagement',
  apiWorkflowDetail: apiUrl + '/WorkflowDetailManagement',
  apiCampaignWorkflow: apiUrl + '/CampaignWorkflowManagement',
  apiWorkflowQueue: apiUrl + '/WorkflowQueueManagement',
  apiWorkflowManagement: apiUrl + '/WorkflowManagement',
  apiWorkFlow: apiUrl + '/WorkFlow',
  userApiToken: apiUrl + '/UserApiTokenManagement',
  apiEmployee: apiUrl + '/EmployeeManagement',
  apiScheduleManagement: apiUrl + '/SchedulingManagement',
  apiBandManagement: apiUrl + '/BandManagement',
  apiInteractiveProposal: apiUrl + '/InteractiveProposalManagement',
  apiTimeOffRequestManagement: apiUrl + '/TimeOffRequestManagement',
  apiTimezoneManagement: apiUrl + '/TimezoneManagement',
  apiSchedulingTypeManagement: apiUrl + '/SchedulingTypeManagement',
  apiCustomerManagement: apiUrl + '/CustomerManagement',
  apiVenueManagement: apiUrl + '/VenueManagement',
  apiVenueInquiry: apiUrl + '/VenueInquiryManagement',
  apiVenueLocation: apiUrl + '/VenueLocation',
  apiOffice: apiUrl + '/CRM/Office',
  apiProjectManagement: apiUrl + '/ProjectManagement',
  apiRevisionVersion: apiUrl + '/RevisionVersion',
  apiDashboardMoneyMaker: apiUrl + '/DashboardMoneyMaker',
  apiContactActivityLog: apiUrl + '/ContactActionLog',
  apiTimeSkip: apiUrl + '/TimeSkipManagement',
  apiIndustry: apiUrl + '/IndustryManagement',
  apiWpLangContent: apiUrl + '/WpLangContentManagement',
  apiCacheManagement: apiUrl + '/CacheManagement',
  apiCloseLostReason: apiUrl + "/CloselostReasonManagement",
  apiWordpress: apiUrl + '/Wordpress'
};
